import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import clsx from 'clsx';
import { getArchiveIcon } from "../../tools";
import { ArchiveViewerView, useArchiveViewerContext } from "../context";
import { ViewerControlTooltip } from "../controls";
import { ArchiveModal, ArchiveModalBody, ArchiveModalCloseButton, ArchiveModalHeader } from "./base";
import '@isyc-react/design/main';
// NOTE: This component needs to be wrapped in an ArchiveViewerProvider
export const ViewerArchiveModal = props => {
  const {
    name,
    show = false,
    onChange,
    balice,
    transform,
    children,
    size
  } = props;
  const {
    setArchiveViewerData
  } = useArchiveViewerContext();
  const classes = React.useMemo(() => getArchiveIcon(name !== null && name !== void 0 ? name : undefined), [name]);
  const portal = React.useRef(null);
  React.useEffect(() => {
    const container = portal.current;
    if (container && show) setArchiveViewerData(data => _objectSpread(_objectSpread({}, data), {}, {
      controlsPortal: container,
      view: ArchiveViewerView.MODAL
    }));
  }, [show]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArchiveModal, {
    show: show,
    balice: balice,
    transform: transform,
    size: size
  }, /*#__PURE__*/React.createElement(ArchiveModalHeader, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-between w-100 h-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center ms-4 me-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: clsx(classes.icon, 'font-size-26 me-2')
  }), /*#__PURE__*/React.createElement(ViewerControlTooltip, {
    tooltip: name !== null && name !== void 0 ? name : ''
  }, /*#__PURE__*/React.createElement("div", {
    className: "title font-size-14"
  }, name)))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-end flex-grow-1 h-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-end flex-grow-1 h-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-100 w-100",
    ref: portal
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-end h-100"
  }, /*#__PURE__*/React.createElement(ArchiveModalCloseButton, {
    onClick: () => onChange && onChange(false)
  }))))), /*#__PURE__*/React.createElement(ArchiveModalBody, null, children)));
};